import React from 'react';

interface SkeletonProps {
    type?: 'text' | 'video';
    shape?: 'circle' | 'square' | '16x9' | 'tall' | '6x3' | '16x12';
    size?: 1 | 2 | 3 | 4 | 5 | 6;
    withPulse?: boolean;
    className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
    type = 'text',
    shape,
    size,
    withPulse = true,
    className = ''
}) => {
    const classes = [
        'component-skeleton',
        type && `type-${type}`,
        shape && `shape-${shape}`,
        size && `size-${size}`,
        withPulse && 'with-pulse',
        className
    ].filter(Boolean).join(' ');

    return <div className={classes} />;
}; 